import { makeStyles } from '@mui/styles';

const Style = makeStyles((theme) => ({
  error: {
    color: theme.palette.error.main,
  },
  autocompleteWhite: {
    backgroundColor: theme.palette.background.default,
    borderRadius: 4,
  },
}));

export default Style;
